import React, {useState} from "react";
import { useFormikContext } from "formik";
import ErrorMessage from "../Input/ErrorrMessage";
import { labelName } from "../../utils/functions";
import TextFieldStyles from "../Input/TextField/TextField.module.css";


export default function ScaleRating({ field_label, displayLabel, parent, isRequired }) {
  const { setFieldValue, values } = useFormikContext();
  const name = parent ? `${parent}.${field_label}` : field_label;
  const [rating, setRating] = useState(0);
  const handleRatingChange = (value) => {
    setRating(value);
    setFieldValue(name, value);
  };

  return (
    <div className={TextFieldStyles.inputContainer}>
      <div className="label-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <label htmlFor="textarea" className={TextFieldStyles.label}>
          {labelName(displayLabel || field_label)}
          {isRequired === "true" && <span style={{ color: '#d32f2f', padding: 0 }}>*</span>}
        </label>
      </div>
      <div style={{ maxWidth: "400px", fontFamily: "Arial, sans-serif" }}>

        <div style={{ display: "grid", gap: "1em", position: "relative", width: "min-content" }}>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1em", margin: "1em auto" }}>
            <input type="hidden" name={name} value={rating} />
            {[1, 2, 3, 4, 5].map((num) => (
              <button
              key={num}
              type="button"
              onClick={() => handleRatingChange(num)}
              style={{
                width: "38px",
                height: "38px",
                borderRadius: "50%",
                border: `2px solid ${values[name] === num ? "#007bff" : "#ccc"}`,
                background: values[name] === num ? "#007bff" : "transparent",
                color: values[name] === num ? "#fff" : "#000",
                fontSize: "16px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "0.3s",
              }}
            >
              {num}
            </button>
            ))}
          </div>
          <span style={{ padding: "0em", fontSize: ".8em", position: "absolute", bottom: "-1em", left: "0"}}>Worst</span>
          <span style={{ padding: "0em", fontSize: ".8em", position: "absolute", bottom: "-1em", right: "0"}}>Best</span>
        </div>


        <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
          {/* <p style={{ marginRight: "5px", color: "#555" }}>({values[name] || 0}) rating</p>| */}
          <button
            type="button"
            onClick={() => handleRatingChange(0)}
            style={{
              margin: "1em 0em",
              padding: "5px 10px",
              backgroundColor: "#d32f2f",
              color: "#fff",
              border: "none",
              fontSize: "12px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Reset
          </button>
        </div>
      </div>
      <ErrorMessage name={name} />
    </div>
  );
}
